import { AnalyticsAction } from '../analyticsActions';

export const Events = {
  [AnalyticsAction.INVEST_OVERVIEW]: 'view_investment',
};
